import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { MandateTypeAdditionalDoc } from "../types/AdditionalDocumentsType";
import { displayError } from "../utils/error-handling";

const fetch =
  (authHeader: string, id: number, type?: "individual" | "entity") => () => {
    const baseUrl = `${env.verifyServiceUrl}individual/mandate_type/${id}/additional_document/`;
    const url = type ? `${baseUrl}?_type=${type}` : baseUrl;

    return axios.get<MandateTypeAdditionalDoc[]>(url, {
      headers: {
        Authorization: authHeader,
      },
       skipGlobalErrorHandler: true,
    });
  };

export const useMandateTypeAdditionalDoc = (
  id: number | null,
  type?: "individual" | "entity"
) => {
  const { authHeader, isLoggedIn } = useAuth();

  return useQuery(
    ["mandateTypeAdditionalDoc", id, type],
    fetch(authHeader, id as number, type),
    {
      enabled: isLoggedIn && id !== null,
      retry: false,
      select: (response) => response.data,
      onError: (err: any) => {
        // const status = err?.request?.status ?? err?.response?.status;

        const message =
          err?.response?.data?.detail ||
          "Something went wrong. Please try again.";

        displayError(message);

        // if (status === 500 || status === 503) {
        //   navigate(ROUTE.SERVER_ERROR);
        // }
      },
    }
  );
};
